import React, { useContext } from 'react';

import {
    AppendStructuredBriefDesigners as AppendStructuredBriefDesignersMutationInterface,
    AppendStructuredBriefDesignersVariables as AppendStructuredBriefDesignersMutationVariables,
} from '__generated__/AppendStructuredBriefDesigners';
import BriefContext from 'projects/components/BriefContext';
import { Mutation, MutationFetchResult, MutationResult } from 'react-apollo';
import mutation from './AppendStructuredBriefDesigners.graphql';

interface Props {
    children: (
        appendStructuredBriefDesigners: (
            variables: AppendStructuredBriefDesignersMutationVariables
        ) => Promise<void | MutationFetchResult<AppendStructuredBriefDesignersMutationInterface>>,
        result: MutationResult
    ) => React.ReactElement;
}

const AppendStructuredBriefDesigners = ({ children }: Props) => {
    const { brief } = useContext(BriefContext);
    const designerIds = brief.designers.map(d => d.id);
    return (
        <Mutation<
            AppendStructuredBriefDesignersMutationInterface,
            AppendStructuredBriefDesignersMutationVariables
        >
            mutation={mutation}
        >
            {(mutation, result) => {
                return children(variables => {
                    return mutation({
                        variables,
                        optimisticResponse: designerIds
                            ? ({
                                  appendStructuredBriefDesigners: {
                                      id: variables.id,
                                      __typename: 'StructuredBrief',
                                      designers: designerIds
                                          .concat(variables.designerIds)
                                          .map(id => ({
                                              id,
                                              __typename: 'User',
                                          })),
                                      designersWithSource: brief.designersWithSource
                                          .map(d => ({
                                              __typename: 'DesignerWithSource',
                                              ...d,
                                          }))
                                          .concat(
                                              variables.designerIds.map(() => ({
                                                  __typename: 'DesignerWithSource',
                                                  source: variables.source,
                                              }))
                                          ),
                                  },
                              } as AppendStructuredBriefDesignersMutationInterface)
                            : undefined,
                    });
                }, result);
            }}
        </Mutation>
    );
};

export default AppendStructuredBriefDesigners;
